import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import html2canvas from 'html2canvas';
import styles from './index.css';
import { getFinanceQrcode } from '@src/services/api';
import { formatImage } from '@ifeng-fe/public_method';
import logo1 from './logo1.png';
import logo2 from './logo2.png';
import box1 from './box1.png';
import box3 from './box3.png';

const getShareTime = time => {
    const date = new Date(time);
    const daysOfWeek = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const y = date.getFullYear();
    let m = date.getMonth() + 1;

    m = m < 10 ? `0${m}` : m;
    let d = date.getDate();

    d = d < 10 ? `0${d}` : d;
    let h = date.getHours();

    h = h < 10 ? `0${h}` : h;
    let minute = date.getMinutes();
    let second = date.getSeconds();

    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;

    return {
        year: `${y}/${m}/${d}`,
        week: daysOfWeek[date.getDay()],
        time: `${h}:${minute}`,
    };
};

class ShareImg extends React.PureComponent {
    static propTypes = {
        curTime: PropTypes.string,
        title: PropTypes.string,
        bref: PropTypes.string,
        url: PropTypes.string,
        img: PropTypes.string,
        handleCompleteShare: PropTypes.func,
    };
    state = {
        qrcodeImageUrl: '',
        isLoading: true,
    };

    box = React.createRef();

    async componentDidMount() {
        const { url } = this.props;
        const shareList = this.box.current;

        try {
            const qrcodeImageUrl = await getFinanceQrcode(url);

            this.setState(
                {
                    qrcodeImageUrl: `https:${qrcodeImageUrl}`,
                },
                () => {
                    this.createPhoto(shareList);
                },
            );
        } catch (e) {
            console.log(e, '获取二维码失败');
        }
    }

    createPhoto = obj => {
        const { curTime, title, bref, img, url } = this.props;
        let brefText = title !== bref && bref ? bref.slice(0, 1000) : '';

        if (brefText.length === 1000) {
            brefText = `${brefText}...`;
        }

        try {
            html2canvas(obj, {
                scale: 2,
                useCORS: true,
            }).then(canvas => {
                this.props.handleCompleteShare();
                this.setState({
                    isLoading: false,
                });
                if (window.grounds) {
                    window.grounds.shareWebCard(
                        canvas.toDataURL('image/png').replace('data:image/png;base64', ''),
                        JSON.stringify({
                            shareurl: url,
                            title,
                            desc: brefText,
                            // thumbnail: canvas.toDataURL('image/png').replace('data:image/png;base64', ''),
                            // documentId: '',
                            // timestamp: '',
                        }),
                    );
                }
                canvas = null;
            });
        } catch (e) {
            console.log(e, '生成图片失败');
        }
    };

    render() {
        const { curTime, title, bref, img } = this.props;
        const { qrcodeImageUrl, isLoading } = this.state;
        const year = getShareTime(curTime).year;
        const week = getShareTime(curTime).week;
        const time = getShareTime(curTime).time;
        let brefText = title !== bref && bref ? bref.slice(0, 1000) : '';
        const dataTime = `${year} ${week} ${time}`;

        if (brefText.length === 1000) {
            brefText = `${brefText}...`;
        }

        return (
            <>
                <div className={styles.shareList} ref={this.box}>
                    <div className={styles.shareHead}>
                        <img className={styles.shareHeadPic} src={logo1} />
                        <div className={styles.shareHeadTime}>{dataTime}</div>
                    </div>
                    <div className={styles.shareBox}>
                        <img className={styles.shareBox1} src={box1} />
                        <img className={styles.shareBox3} src={box3} />
                        {title && <div className={styles.shareBoxTitle}>{title}</div>}
                        {title && brefText && <div className={styles.shareVspace50} />}
                        {brefText && <div className={styles.shareBoxBref}>{brefText}</div>}
                        {img && <img className={styles.shareBoxImg} src={formatImage(img, 750)} />}
                    </div>
                    <div className={styles.shareFoot}>
                        <img className={styles.shareFootPic} src={logo2} />
                        <img className={styles.shareFootQrcode} src={qrcodeImageUrl} />
                    </div>
                </div>
                {isLoading && (
                    <div className={styles.loadingBox}>
                        <div className={styles.loading} />
                    </div>
                )}
            </>
        );
    }
}

export default errorBoundary(ShareImg);
